export class TransportMutationContractError extends Error {
    constructor(public readonly cause: unknown) {
        super("Transport mutation succeeded but its response did not match the API contract");
        this.name = "TransportMutationContractError";
    }
}

export const isTransportMutationContractError = (error: unknown): error is TransportMutationContractError =>
    error instanceof TransportMutationContractError;
